export const DB_URI =
    'https://cors-anywhere.herokuapp.com/https://dons-blog-server.herokuapp.com/';
